import { render, staticRenderFns } from "./HeaderLogos.vue?vue&type=template&id=236d7742&scoped=true"
import script from "./HeaderLogos.vue?vue&type=script&lang=js"
export * from "./HeaderLogos.vue?vue&type=script&lang=js"
import style0 from "./HeaderLogos.vue?vue&type=style&index=0&id=236d7742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d7742",
  null
  
)

export default component.exports